// Janela de serviço do WhatsApp: 24h a partir da última mensagem do cliente.
// Dentro da janela o negócio responde com texto livre e grátis; fora, só
// template pago. Lógica pura — sem React, sem I/O.

export type Janela24hEstado = 'aberta' | 'a_fechar' | 'fechada' | 'nenhuma';

export interface Janela24h {
  estado: Janela24hEstado;
  /** ms até fechar; null quando 'fechada' ou 'nenhuma'. */
  msRestantes: number | null;
}

const JANELA_MS = 24 * 60 * 60 * 1000;
const LIMIAR_A_FECHAR_MS = 2 * 60 * 60 * 1000;

export function resolverJanela24h(
  ultimaMsgClienteEm: Date | null,
  agora: Date,
): Janela24h {
  if (!ultimaMsgClienteEm) return { estado: 'nenhuma', msRestantes: null };
  const restante = ultimaMsgClienteEm.getTime() + JANELA_MS - agora.getTime();
  if (restante <= 0) return { estado: 'fechada', msRestantes: null };
  if (restante <= LIMIAR_A_FECHAR_MS) return { estado: 'a_fechar', msRestantes: restante };
  return { estado: 'aberta', msRestantes: restante };
}

export function formatarTempoRestante(ms: number): string {
  const horas = Math.floor(ms / 3_600_000);
  const min = Math.floor((ms % 3_600_000) / 60_000);
  return horas > 0 ? `${horas}h ${min}m` : `${min}m`;
}
